import React, { useEffect, useRef } from 'react';
import { FaCheckCircle, FaExclamationCircle, FaInfoCircle } from 'react-icons/fa';
import '../styles/mobile-popup.css';

const MobilePopup = ({ message, onClose, type = 'top', status = 'success', duration = 3000 }) => {
    const timeoutRef = useRef(null);
    const popupRef = useRef(null);

    useEffect(() => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        // Reset any existing fade-out animation
        if (popupRef.current) {
            popupRef.current.classList.remove('fade-out');
            void popupRef.current.offsetWidth; // Trigger a reflow to restart animations
        }

        // Set a new timeout for the fade-out effect and closing
        timeoutRef.current = setTimeout(() => {
            if (popupRef.current) {
                popupRef.current.classList.add('fade-out');
            }
            setTimeout(onClose, 400); // Shorter, crisper exit transition
        }, duration);

        return () => clearTimeout(timeoutRef.current);
    }, [message, onClose, duration]);

    const getStatusIcon = () => {
        switch (status) {
            case 'error':
                return <FaExclamationCircle className="mobile-popup-icon error" />;
            case 'info':
                return <FaInfoCircle className="mobile-popup-icon info" />;
            case 'success':
            default:
                return <FaCheckCircle className="mobile-popup-icon success" />;
        }
    };

    return (
        <div ref={popupRef} className={`mobile-popup ${type === 'top' ? 'mobile-popup-top' : 'mobile-popup-bottom'} status-${status}`}>
            <div className="mobile-popup-content">
                {getStatusIcon()}
                <span className="mobile-popup-text">{message}</span>
            </div>
        </div>
    );
};

export default MobilePopup;
